import React from 'react';
export var ResponsiveContainerContext = /*#__PURE__*/React.createContext(false);